<template>
  <div class="container">
    <div class="title" v-if="titleVisible">{{title}}</div>
    <iframe ref="mapFrame" style="width:100%;height:100%;overflow: hidden;" frameborder=0 name="showHere" scrolling=auto
            :src="url"></iframe>
    <div class="footer add-btn-box" v-if="optVisible">
      <Button v-if="refuseVisible" type="primary" style="border-radius: 4px;margin-right: 5px;" @click="commitRefuse()">
        拒绝
      </Button>
      <Button type="primary" style="border-radius: 4px;">签署</Button>
    </div>
  </div>
</template>
<script>
  import $api from "@/apiProvider";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    data() {
      return {
        url: '',
        title: '',
        contractId: null,
        state: null,
        optVisible: false,
        refuseVisible: false,
        titleVisible: true,
      }
    },
    methods: {
      init(row) {
        this.url = '';
        this.title = row.contractName;
        this.contractId = row.id;
        this.state = row.state;
        if (row.state === 1) {
          this.optVisible = true;
          this.refuseVisible = false;
        } else {
          this.optVisible = false;
          this.refuseVisible = false;
        }

        this.titleVisible = true;
        this.url = row.docUrl;
      },

      commitRefuse() {
        this.$XModal.confirm("您确定要拒绝吗？").then((type) => {
          if (type === "confirm") {
            this.refuseContractPallet();
          }
        });
      },
      async refuseContractPallet() {
        let res = await $api.eleContract.request("refuseContractPallet", {
          id: this.contractId,
        });
        if (res.status === 1) {
          this.$Message.success("拒绝成功");
          this.$emit('close');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    }
  }
</script>
<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
  }

  .pdf-content {
    height: 100%;
    overflow: auto;
  }

  .title {
    text-align: center;
  }

  .footer {
    width: 95%;
    box-sizing: border-box;
    padding: 20px 0;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
  }
</style>